import {
  getDigitsOnly,
} from "./helpers";

export function validFirstName(firstName) {
  var nameRegex = RegExp('^[а-яА-ЯёЁ\-]+$');
  return (firstName && firstName.length > 0 && nameRegex.test(firstName));
};

export function validLastName(lastName) {
  var nameRegex = RegExp('^[а-яА-ЯёЁ\-]+$');
  return (lastName && lastName.length > 0 && nameRegex.test(lastName));
};

export function validEmail(email) {
  var emailRegex = RegExp('^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$');
  return (email && email.length > 0 && emailRegex.test(email));
};


export function validPassword(pass) {
  return (!pass || pass.length >= 6);
};

export function validNewPasswordsEquality(newPass, newPassAgain) {
  return !(
    (newPass || newPassAgain)
    &&
    (newPass !== newPassAgain)
  );    
};

export function validPhone(phone) {
  let phoneNumber = getDigitsOnly(phone);

  if (phoneNumber.length != 11) {
    return false;
  }

  if (phoneNumber.length > 0 && phoneNumber.charAt(0) !== '7') {
    return false;
  }

  return true;
}